
export default {
  meta: {
    seo: {
      title: 'site.contact.title',
      description: 'site.contact.description'
    }
  }
}
